import React, { useEffect, useState } from 'react'
import { Table, Card, Tag, Select, Button, Modal, message, Space } from 'antd'
import { listOrders, updateOrderStatus, Order } from '../../api/admin'

const statusOptions = [
  { value: 'voting', label: '投票中', color: 'orange' },
  { value: 'approved', label: '已通过', color: 'green' },
  { value: 'rejected', label: '已拒绝', color: 'red' },
  { value: 'purchased', label: '已购买', color: 'blue' }
]

const Orders: React.FC = () => {
  const [orders, setOrders] = useState<Order[]>([])
  const [loading, setLoading] = useState(true)
  const [statusFilter, setStatusFilter] = useState<string | undefined>()

  useEffect(() => {
    loadOrders()
  }, [statusFilter])

  const loadOrders = async () => {
    try {
      const data = await listOrders({ page: 1, page_size: 100, status: statusFilter })
      setOrders(data)
    } catch {
      // 错误已在拦截器中处理
    } finally {
      setLoading(false)
    }
  }

  const handleStatusChange = async (orderId: number, newStatus: string) => {
    Modal.confirm({
      title: '确认修改状态',
      content: '确定要修改这个订单的状态吗？',
      onOk: async () => {
        try {
          await updateOrderStatus(orderId, newStatus)
          message.success('状态已更新')
          loadOrders()
        } catch {
          // 错误已在拦截器中处理
        }
      }
    })
  }

  const getStatusTag = (status: string) => {
    const option = statusOptions.find(o => o.value === status)
    return <Tag color={option?.color}>{option?.label || status}</Tag>
  }

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80
    },
    {
      title: '标题',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true
    },
    {
      title: '金额',
      dataIndex: 'coin_cost',
      key: 'coin_cost',
      render: (cost: number) => (
        <span style={{ fontWeight: 'bold', color: '#faad14' }}>
          🪙 {cost}
        </span>
      )
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => getStatusTag(status)
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date: string) => new Date(date).toLocaleString('zh-CN')
    },
    {
      title: '操作',
      key: 'action',
      render: (_: unknown, record: Order) => (
        <Space>
          {record.status === 'voting' && (
            <>
              <Button
                type="link"
                size="small"
                onClick={() => handleStatusChange(record.id, 'approved')}
              >
                通过
              </Button>
              <Button
                type="link"
                danger
                size="small"
                onClick={() => handleStatusChange(record.id, 'rejected')}
              >
                拒绝
              </Button>
            </>
          )}
          {record.status === 'approved' && (
            <Button
              type="link"
              size="small"
              onClick={() => handleStatusChange(record.id, 'purchased')}
            >
              标记已购买
            </Button>
          )}
        </Space>
      )
    }
  ]

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
        <h2>📦 订单管理</h2>
        <Select
          placeholder="筛选状态"
          allowClear
          style={{ width: 150 }}
          value={statusFilter}
          onChange={setStatusFilter}
          options={statusOptions}
        />
      </div>

      <Card>
        <Table
          columns={columns}
          dataSource={orders}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 20 }}
        />
      </Card>
    </div>
  )
}

export default Orders
